import { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import { FaRegWindowClose } from "react-icons/fa";

// Custom hook for detecting dark mode
const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    const darkModeMediaQuery = window.matchMedia(
      "(prefers-color-scheme: dark)"
    );

    const handleChange = (event) => {
      setIsDarkMode(event.matches);
    };

    darkModeMediaQuery.addEventListener("change", handleChange);

    return () => {
      darkModeMediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return isDarkMode;
};

export default function App() {
  const [isOnline, setIsOnline] = useState(true);
  const isDarkMode = useDarkMode(); // Get the dark mode state

  useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
    }

    function handleOffline() {
      setIsOnline(false);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const refreshPage = () => {
    window.location.reload();
  };

  // Apply dark mode styles
  const appStyle = isDarkMode
    ? {
        backgroundColor: "#121212", // Dark background
        color: "#ffffff", // Light text
        minHeight: "100vh",
        padding: "20px",
      }
    : {
        minHeight: "100vh",
        padding: "20px",
      };

  return (
    <div style={appStyle}>
      <h1
        style={{
          color: isOnline ? "#55C4FB" : "red",
          fontSize: "2rem",
          textAlign: "center",
          marginBottom: "20px",
        }}>
        {isOnline ? (
          <>
            <FaCheck style={{ marginRight: "18px" }} />
            You are online
          </>
        ) : (
          <>
            <FaRegWindowClose style={{ marginRight: "18px" }} />
            You are offline
          </>
        )}
      </h1>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
        }}>
        <button
          onClick={refreshPage}
          style={{
            padding: "10px 20px",
            fontSize: "1rem",
            backgroundColor: "#55C4FB",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}>
          Refresh Page
        </button>
      </div>

      <div style={{ textAlign: "right" }}>
        <div style={{ minHeight: "360px" }}>
          <div
            style={{
              width: "100%",
              height: "0",
              paddingBottom: "50%",
              position: "relative",
            }}>
            <iframe
              style={{
                border: "none",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                minHeight: "360px",
                overflow: "hidden",
              }}
              src="//openspeedtest.com/speedtest"
              title="Speed Test"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
